import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';

const styles = () => ({
  tableWrapper: {
    padding: '0 0 25px 0',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    '& tr:nth-of-type(odd)': {
      backgroundColor: '#f3f3f3',
    },
  },
  title: {
    fontWeight: 'bold',
    textWrap: 'wrap',
  },
  field: {
    padding: '12px 15px',
    paddingRight: '10px',
  },
  row: {
    borderBottom: '1px solid #dddddd',
    width: '100%',
  },
  options: {
    display: 'flex',
    marginBottom: '5px',
    marginTop: '5px',
  },
  option: {
    flex: 1,
    alignContent: 'center',
  },
  image: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    float: 'left',
    height: '100%',
    maxHeight: '100%',
    maxWidth: '80px',
    marginRight: '10px',
    fontSize: 0,

    '& img': {
      maxHeight: '100%',
      maxWidth: '100%',
    },
  },
  optionList: {
    margin: 0,
    padding: 0,
  },
});

class ConfigurationOverview extends React.Component {
  static propTypes = {
    optionclassifications: PropTypes.array,
    classes: PropTypes.object,
  };

  render() {
    const { optionclassifications, classes } = this.props;

    const renderImage = (thumbnail) => {
      const src = thumbnail && getImageUrl(thumbnail);
      return src && <img src={src} />;
    };

    return (
      <div className={classes.tableWrapper}>
        <table className={classes.table}>
          <tbody>
            {optionclassifications?.map(
              (optionclassification) =>
                !optionclassification.hiddenInFrontend && (
                  <tr key={optionclassification.identifier} className={classes.row}>
                    <td className={classes.field} width={'35%'}>
                      <Typography className={classes.title}>{optionclassification.title}</Typography>
                    </td>
                    <td className={classes.field}>
                      <ul className={classes.optionList}>
                        {optionclassification.selectedoptions?.map((option) => (
                          <li key={option.identifier} className={classes.options}>
                            {option.hasTextinput ? (
                              <Typography className={classes.option}>
                                {option.title}: <b>{option.inputText}</b>
                              </Typography>
                            ) : (
                              <>
                                {option?.thumbnail && (
                                  <div className={classes.image}>{renderImage(option.thumbnail)}</div>
                                )}
                                <Typography className={classes.option}>
                                  {option.amount !== 1 ? (
                                    <>
                                      {option.amount} x {option.title}
                                    </>
                                  ) : (
                                    option.title
                                  )}
                                </Typography>
                              </>
                            )}
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                )
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withStyles(styles, { name: 'ConfigurationOverview' })(ConfigurationOverview);
